import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap-v5";
import { RiCloseFill } from "react-icons/ri";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import BlogService from "../../Services/BlogService";
import AddBlog from "./AddBlog";
import { MdEdit } from "react-icons/md";

let style = {
  position: "absolute",
  right: "17px",
  top: "8px",
  color: "white",
  fontSize: "20px",
  background: "red",
  borderRadius: "10px",
};

const BlogList = () => {
  const history = useHistory();
  const [blogdata, setBlogdata] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  // const [editModal, setEditModal] = useState(false);
  // const [editId, setEditId] = useState("");
  const [loader, setLoader] = useState(false);
  const [asigncat, setAsigncat] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);

  let img_url = process.env.REACT_APP_API_BASEURL;

  const getBlogs = async () => {
    setLoader(true);
    let param = { ...pagination, page: currentPage };
    await BlogService.getBlog(param).then((res) => {
      setLoader(false);
      setPagination({ ...pagination, ...res.pagination });
      setBlogdata(res.data);
    });
  };

  const handleDelete = async () => {
    const obj = {
      id: deleteId,
    };
    await BlogService.deleteBlog(obj).then((res) => {
      setLoader(true);
      if (res.status) {
        setLoader(false);
        getBlogs();
        toast.success(res.message);
        setDeleteModal(false);
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };


  // const handleEdit = async () => {
  //   const obj = {
  //     
  //     id: editId,
  //   };
  //   await BlogService.editBlog(obj).then((res) => {
  //     setLoader(true);
  //     if (res.status) {
  //       setLoader(false);
  //       getBlogs();
  //       toast.success(res.message);
  //       setDeleteModal(false);
  //     } else {
  //       setLoader(false);
  //       toast.error(res.message);
  //     }
  //   });
  // };

  const handleDeleteModal = (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  // const handleEditModal = (id) => {
  //   setEditModal(true);
  //   setEditId(id);
  // }
  const onPageChangeEvent = (e) => {
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  useEffect(() => {
    getBlogs();
  }, [currentPage]);
  return (
    <div>
      <div className="card">
        <div className="card-body">
          <div className="text-end mb-3">
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => setAddModal(true)}
            >
              Add Blog
            </Button>
          </div>
          <div className="row">
            {blogdata &&
              blogdata.map((item, index) => {
                return (
                  <div
                    className="col-sm-3 mt-3 position-relative"
                    
                  >
                  <div style={{ border: "2px solid #6ED5C4", height : "450px" }}>
                    <img
                      style={{ width: "100%", height: "300px" }}
                      src={img_url + "/" + item?.image}
                      alt=""
                    />
                    <RiCloseFill
                      onClick={() => handleDeleteModal(item._id)}
                      style={style}
                    />
                    {/* <MdEdit
                          className="pointer"
                          onClick={() => handleEditModal(item._id)}
                          style={{ fontSize: "22px", color: "rgb(3, 35, 254)" }}
                        /> */}
                    <div className="p-3">
                    <h5>{item?.title?.slice(0, 15)}</h5>
                    <div dangerouslySetInnerHTML={{__html: item?.description?.slice(0, 13)}}></div>
                  </div>
                  </div>
                  </div>
                );
              })}
          </div>

          <div className="text-center">
            {(loader && <Spinner animation="grow" size="sm" />) || ""}
          </div>
          {blogdata?.length <= 0 && !loader && (
            <div className="text-center w-100 bg-warning my-5">
              {/* {/ {/ <Spinner animation="grow" size="sm" /> /} /} */}
              {/* {/ {/ <Loader isShow={loader}/> /} /} */}
              <h6 className="py-2"> list not available </h6>
            </div>
          )}

          {blogdata &&
            blogdata.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={
                  <img
                    src="assets/images/prev.svg"
                    height={15}
                    alt="not found"
                  />
                }
                forcePage={currentPage - 1}
                nextLabel={
                  <img
                    src="assets/images/next.svg"
                    height={15}
                    alt="not found"
                  />
                }
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}

          {/* {/ {/ Add Modal /} /} */}

          <Modal
            show={addModal}
            onHide={() => setAddModal(false)}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Add Blog</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* {/ <AddGallery setAddModal={setAddModal} getBlogs={getBlogs}/> /} */}
              <AddBlog
              // setAddModal(true)
              // onClick={() => setAddModal(true)}
              setAddModal={setAddModal} getBlogs={getBlogs}/>
            
            </Modal.Body>
          </Modal>

          {/* {/ {/ Delete Modal /} /} */}

          <Modal
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Delete Blog</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h6>Are you sure want to delete Blog</h6>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setDeleteModal(false)}>
                Close
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                {(loader && <Spinner animation="grow" size="sm" />) || "Delete"}
              </Button>
            </Modal.Footer>
          </Modal>


          {/* <Modal
            show={editModal}
            onHide={() => setEditModal(false)}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Blog</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h6>Are you sure want to edit Blog</h6>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setEditModal(false)}>
                Close
              </Button>
              <Button variant="danger" 
              // onClick={handleEdit}
              >
                {(loader && <Spinner animation="grow" size="sm" />) || "Delete"}
              </Button>
            </Modal.Footer>
          </Modal> */}

          {/* <Modal
          show={asigncat}
          onHide={() => setAsigncat(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Assign Sub Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            abc
          </Modal.Body>
          <Modal.Footer>
            <Button
              style={{ zIndex: 9 }}
              type="button"
              // onClick={submitSubcat}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal> */}
        </div>
      </div>
    </div>
  );
};

export default BlogList;
